import { FHIRQueryResourceParamType_Dynamic, FHIRQueryResourceParamType_Mandatory, FHIRQueryResourceParamType_Optional } from './types.js';
//################################### General ###################################
export const FHIRQueryResourceParam_Patient = { param: 'patient', type: FHIRQueryResourceParamType_Dynamic };
export const FHIRQueryResourceParam_Encounter = { param: 'encounter', type: FHIRQueryResourceParamType_Dynamic };
//################################### Condition ###################################
export const FHIRQueryResourceParam_Condition_Category = {
    type: FHIRQueryResourceParamType_Mandatory,
    param: 'category',
    values: [
        { value: 'encounter-diagnosis', label: 'Encounter Diagnosis' },
        { value: 'infection', label: 'Infection' },
        { value: 'reason-for-visit', label: 'Reason For Visit' },
        { value: 'medical-history', label: 'Medical History' }
    ]
};
//################################### DocumentReference ###################################
export const FHIRQueryResourceParam_DocumentReference_Category = {
    type: FHIRQueryResourceParamType_Mandatory,
    param: 'category',
    values: [{ value: 'clinical-note', label: 'Clinical Note' }],
};
export const FHIRQueryResourceParam_DocumentReference_DocStatus = {
    type: FHIRQueryResourceParamType_Mandatory,
    param: 'docstatus',
    values: [
        { value: 'preliminary', label: 'Preliminary' },
        { value: 'final', label: 'Final' },
        { value: 'amended', label: 'Amended' },
        { value: 'entered-in-error', label: 'Entered In Error' },
    ]
};
export const FHIRQueryResourceParam_DocumentReference_Type = {
    type: FHIRQueryResourceParamType_Optional,
    param: 'type',
    values: [
        { value: '18842-5', label: 'Discharge Documentation' },
        { value: '11488-4', label: 'Consultation' },
        { value: '34117-2', label: 'History & Physical' },
        { value: '11506-3', label: 'Progress Note' },
        { value: '28570-0', label: 'Procedure Note' },
        { value: '34111-5', label: 'Emergency Department Note' },
        { value: '34746-8', label: 'Nurse Note' },
        { value: '74213-0', label: 'Discharge Instructions' },
        { value: '75492-9', label: 'Risk assessment and screening note' },
    ],
};
//################################### List ###################################
export const FHIRQueryResourceParam_List_Code = {
    param: 'code',
    type: FHIRQueryResourceParamType_Optional,
    values: [{ value: 'medications', label: 'Medications' }],
};
//################################### MedicationRequest ###################################
export const FHIRQueryResourceParam_MedicationRequest_Category = {
    type: FHIRQueryResourceParamType_Optional,
    param: 'category',
    values: [
        { value: 'Inpatient', label: 'Inpatient' },
        { value: 'Outpatient', label: 'Outpatient' },
        { value: 'Community', label: 'Community' },
        { value: 'Discharge', label: 'Discharge' },
    ]
};
export const FHIRQueryResourceParam_MedicationRequest_Status = {
    type: FHIRQueryResourceParamType_Optional,
    param: 'status',
    values: [
        { value: 'on-hold', label: 'On Hold' },
        { value: 'completed', label: 'Completed' },
        { value: 'stopped', label: 'Stopped' },
        { value: 'active', label: 'Active' },
    ]
};
//################################### Observation ###################################
export const FHIRQueryResourceParam_Observation_Category = {
    type: FHIRQueryResourceParamType_Optional,
    param: 'category',
    values: [
        { value: 'vital-signs', label: 'Vital Signs' },
        { value: 'social-history', label: 'Social History' },
    ]
};
export const FHIRQueryResourceParam_Observation_Code = {
    type: FHIRQueryResourceParamType_Optional,
    param: 'code',
    values: [
        { value: '82810-3', label: 'Pregnancy Status' },
        { value: '3146-8', label: 'Menstrual Status' },
        { value: '63895-7', label: 'Lactation Status' },
        { value: '72166-2', label: 'Smoking History' },
        { value: '32486-3', label: 'Physical Findings of Uterus' },
        { value: '11778-8', label: 'Estimated Delivery Date' },
        { value: '8665-2', label: 'Last Menstrual Period' },
        { value: '86645-9', label: 'Pregnancy Intention' },
    ]
};
//################################### Procedure ###################################
export const FHIRQueryResourceParam_Procedure_Category = {
    type: FHIRQueryResourceParamType_Mandatory,
    param: 'category',
    values: [{ value: '387713003', label: 'Surgeries / Surgical History' }],
};
//# sourceMappingURL=categories.js.map